import React from "react";
import { useMediaQuery } from "react-responsive";
import JoinUsPage from "../pages/JoinUsPage.jsx";


const ResponsiveJoinUsPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Mobile breakpoint
  return isMobile ? <JoinUsPage /> : <JoinUsPage />;
};

export default ResponsiveJoinUsPage;
